import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { HttpService } from '../../commons/services/http.service';
import { RegistroMasivo } from '../../commons/class/user.class';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { ENV_TOKEN } from '../../app-module.token';

//const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
//const EXCEL_EXTENSION = '.xlsx';
@Injectable({ providedIn: 'root' })
export class AltaUsuariosMasService {
  headers = new HttpHeaders();
  public constService: any;
  urlRaiz!: string;

  readonly environment = inject(ENV_TOKEN);
  private httpService: HttpService = inject(HttpService);
  private httpClient: HttpClient = inject(HttpClient);

  constructor() {
    this.constService = this.environment;
    this.urlRaiz = this.constService.gateway;
  }

  /**
   * Carga masiva de usuarios, se construye la ruta para la carga utilizando la URL raíz y la función correspondiente, se hace una petición POST al servicio utilizando la ruta construida y el objeto de solicitud proporcionado, se retorna la respuesta del servicio
   * @param request 
   * @returns 
   */
  CargaMasiva(request: RegistroMasivo) {
    const funcion = "icoij/MassUserRegistration"; 
    const ruta = `${this.urlRaiz}/${funcion}`;
    return this.httpService.postRequest(ruta, request)
  }

  /**
   * Exporta datos a un archivo Excel, se convierte el arreglo de datos a una hoja de cálculo utilizando la biblioteca XLSX, se aplican estilos a los encabezados, se crea un libro de trabajo con la hoja de cálculo, se escribe el libro de trabajo en un buffer y se guarda como un archivo utilizando la biblioteca FileSaver
   * @param data 
   * @param fileName 
   */
  exportToExcel(data: any[], fileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
    // Obtener el rango de la hoja
    const range = XLSX.utils.decode_range(worksheet['!ref']!);
    // Aplicar formato a los headers (primera fila)
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: C });
      const cell = worksheet[cellAddress];
      if (cell) {
        cell.s = {
          font: { bold: true, color: { rgb: 'FFFFFF' } }, // Negritas y blanco
          fill: { fgColor: { rgb: '4F81BD' } },           // Fondo azul
          alignment: { horizontal: 'center' }             // Centrado
        };
      }
    }
    // Crear el libro
    const workbook: XLSX.WorkBook = {
      Sheets: { data: worksheet },
      SheetNames: ['data']
    };

    const excelBuffer: any = XLSX.write(workbook, {
      bookType: 'xlsx',
      type: 'array',
      cellStyles: true // Importante para que se apliquen estilos
    });

    const blob: Blob = new Blob([excelBuffer], {
      type: 'application/octet-stream'
    });

    FileSaver.saveAs(blob, `${fileName}.xlsx`);
  }
}